module.exports = __webpack_public_path__ + "static/img/logo-comodo.9865313d.png";